
<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
  <nx-message context="{{ alertType[alert.type].toLowerCase() }}" closable="true" (close)="removeAlert(alert)">
    <div [innerHTML]="alert.message"></div>
  </nx-message>
</div>
